import React from 'react';
import { Grid, Paper, Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';

const handleSSOLogin = (navigate) => {
    const ssoBaseUrl = process.env.REACT_APP_SSO_BASE_URL || "https://auth.connectwise.com";
    const ssoAuthUri = "/connect/authorize";
    const ssoClientId = process.env.REACT_APP_SSO_CLIENT_ID || "cw.sidekick";
    const ssoScope = "profile openid email api.manage api.productinstances offline_access";
    const ssoRedirectUri = process.env.REACT_APP_SSO_REDIRECT_URI || `https://${window.location.host}/auth-end`;

    const url = `${ssoBaseUrl}${ssoAuthUri}?client_id=${ssoClientId}&response_type=code&scope=${ssoScope}&redirect_uri=${ssoRedirectUri}`;

    const width = 600;
    const height = 600;
    const left = (window.innerWidth - width) / 2;
    const top = (window.innerHeight - height) / 2;

    const loginWindow = window.open(url, 'ConnectWise - SSO Login', `width=${width},height=${height},top=${top},left=${left}`);

    const messageListener = (event) => {
        console.log("event: ", event.data);
        if (event.origin !== window.location.origin) {
            return;
        }

        if (event.data.type === 'SSO_LOGIN_SUCCESS') {
            const token = event.data.token;
            sessionStorage.setItem('ssoToken', token);
            loginWindow.close();
            window.removeEventListener('message', messageListener);
            sessionStorage.setItem('isAuthenticated', true);
            navigate('/provision');
        } else if (event.data.type === 'SSO_LOGIN_ERROR') {
            console.error('SSO Login Error:', event.data.error);
            loginWindow.close();
            window.removeEventListener('message', messageListener);

            // Handle login error
            const errorAlert = document.createElement('div');
            errorAlert.innerText = 'An error occurred during SSO login. Please try again.';
            errorAlert.style.position = 'fixed';
            errorAlert.style.top = '20px';
            errorAlert.style.left = '50%';
            errorAlert.style.transform = 'translateX(-50%)';
            errorAlert.style.backgroundColor = 'red';
            errorAlert.style.color = 'white';
            errorAlert.style.padding = '10px';
            errorAlert.style.borderRadius = '5px';
            document.body.appendChild(errorAlert);

            setTimeout(() => {
                document.body.removeChild(errorAlert);
            }, 5000);
        }
    };

    window.addEventListener('message', messageListener);
};

const Login = () => {
    const navigate = useNavigate();

    return (
        <Grid container justifyContent="center" alignItems="center" sx={{ minHeight: '100vh' }}>
            <Grid item xs={12} sm={8} md={6} lg={4}>
                <Paper sx={{ padding: 2, textAlign: 'center', color: 'text.secondary', backgroundColor: 'ghostwhite' }}>
                    <img src={`${process.env.PUBLIC_URL}/CW-Horz-Blue-300x100.png`} alt="Logo" />
                    <form>
                        <Button
                            fullWidth
                            variant='contained'
                            onClick={() => handleSSOLogin(navigate)}
                            color="secondary"
                            sx={{ mt: 2 }}
                        >
                            Sign In CW SSO
                        </Button>
                    </form>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default Login;
